import { BehaviorSubject } from 'rxjs';
import { FIELD_KIND, WizConstants } from '@wizeoo/akm-compute-lib';
import { ComparatorVO } from '../vo/common/tool/comparator.vo';
import { FakeVO } from '../vo/common/tool/fake.vo';
import { API_FORMAT, API_PARAM_KIND, AUTH_KIND, BDD_KIND, CNX_KIND, COMPARATOR, CONNECT_RETURN_ACTION, CONTEXT_DATA, ENGINE_KIND, ENGINE_OPERATION_KIND, ENGINE_OPERATION_SCEN_KIND, EXIT_STATUS, FTP_PROTOCOL_KIND, LOG_KEY_KIND, MAPPING_SPECIAL_KIND, PARTITION_KIND, PREDEFINE_KIND, PREDEFINED_SQL_PARAM, PROC_OP_TYPE, PROCESS_MODE, PROCESSOR_TYPE, PROCESSOR_WAY, READER_KIND, REPEAT_CONDITION_KIND, SQL_TYPE, STEP_EVENT_KIND, WORKFLOW_STATE, WORKING_TABLE_WAY, WRITER_KIND } from './enums';
import { WizActionObj } from '@wizeoo/akm-component-lib';
import { GridType } from 'angular-gridster2';
import { WIZ_COMMAND_HTTP_METHOD } from '@wizeoo/akm-core-lib';

/**
 * conteneur de données (singleton)
 * Données NON métier uniquement & constantes
 * Tout le stuff par défaut
 */
export class ViewData extends WizConstants {
  // l'instance (unique)
  private static _instance: ViewData = null;

  /** accesseur sur l'instance, créa si nécessaire */
  public static getInstance(): ViewData {
    if (!this._instance) {
      this._instance = new ViewData();
    }
    return this._instance;
  }

  /** copie d'un widget sur 2x clic */
  public static widgetCopy: any = null;

  /**
   * alimenté par la navigation
   * utilisé par le user-context pour déterminer le tab
   */
  public static currentTab: WizActionObj = null;


  private static startTime: number;

  public static doStart(): void {
    this.startTime = new Date().getTime(); // début mesure
  }

  public static doEnd(mess: string): void {
    let endTime = new Date().getTime(); // fin mesure
    let totalComputeTime = (endTime - this.startTime) / 1000;
    console.log(mess, totalComputeTime);
  }


  public static VISION_CHRONO_REGEXEP: RegExp = /^CHRONO/; // regexp de recherche chronocode dans une clé
  public static VISION_FDV_LEVEL_REGEXP: RegExp = /#[0-9]+/m; // regexp de recherche freedatalevel dans une clé

  public static KEY_SPLIT_REGEXP: RegExp = /\|/; // Expression régulière permettant de splitter les clés (on split sur le pipe)

  public static CODE_REGEXP: RegExp = /^[a-zA-Z0-9\-]+$/; // Expression régulière d'un code (alphaNum & _)
  public static ALPHANUMERIC_REGEXP: RegExp = /^[a-zA-Z0-9]+$/; // Expression régulière d'un alphanuméric (aucun autre caractère)

  public static EXCEL_EXPORT_SEPARATOR: string = '$_$'; // séparateur de champs pour export Excel

  public static wildcardDomainLiteral: string = 'WIZEOO'; // le domaine de base des codifs bas niveau, utilisé aussi comme base pour bu
  public static wildcardMainVision: string = '__SETTINGS'; // la vision * de configuration
  public static wildcardMainScenario: string = 'MAIN'; // la scenario source
  public static settingsIcon: string = 'settings.png'; // le média pour affichage des visions de conf.

  public static CONTEXT_LOCAL_KEY: string = 'CONTEXT_LOCAL'; // emplacement de stockage

  public static TECH_FEATURE = 'TECH_FEATURE'; // constante des features techniques
  public static DYNA_FEATURE = 'DYNA_FEATURE'; // constante des features dynamiques (par vision, step, tab..)
  public static DATA_FEATURE = 'DATA_FEATURE'; // constante des features de données (pools d'accès)

  public static DEFAULT_SCENARIO = 'MAIN'; // code du scénario de base
  public static NONE = '#NONE#'; // suppression des libellés


  public static MAX_STEP_LINES: number = 1000000; // pas plus de 200000 lignes par vision
  public static MAX_UPDATE_IN_A_SHOT: number = 100000; // pas plus de 300 modifs sur un commit

  public static THUMB_MAX_SIZE: number =  300; // taille au dessus de laquelle on utilise l'image, pas le thumb

  public static defaultRowHeight: number = 30; // taille des lignes du grid par défaut
  public static defaultHeaderHeight: number = 35; // taille des headers du grid par défaut
  public static ATTACHMENT_ERROR: string = 'ERROR'; // code d'erreur de binaires introuvables


  public static FORM_TITLE: string = 'FORM_TITLE'; // constante de rendu fake pour les forms
  public static FORM_LABEL: string = 'FORM_LABEL'; // constante de rendu fake pour les forms
  public static FORM_COMMENT: string = 'FORM_COMMENT'; // constante de rendu fake pour les forms

  public static FORM_HTML: string = 'FORM_HTML'; // constante de contenu html statique
  public static FORM_IMAGE: string = 'FORM_IMAGE'; // constante de contenu image (storage)
  public static FORM_ACTION: string = 'FORM_ACTION'; // constante de contenu Connect
  public static FORM_DROP: string = 'FORM_DROP'; // zone de drop de fichier
  public static FORM_ZONE: string = 'FORM_ZONE'; // zone de contenu (accordéon)
  
  public static FILTER_GENERIC: string = 'FILTER_GENERIC'; // filtre sur tous les champs du widget
  public static FILTER_ME: string = 'FILTER_ME'; // filtre sur "moi" comme créateur / modificateur (FDV)

  /** mode de rendu par défaut des gridsters */
  public static DEFAULT_SCREEN_MODE: GridType = GridType.VerticalFixed;
  /** mode de rendu d'édition (fiex) */
  public static TEMPLATE_SCREEN_MODE: GridType = GridType.Fixed;


  // un onglet de fonction basique
  public static KIND_STATIC: string = 'static';
  // un onglet issu d'un template
  public static KIND_DYNAMIC: string = 'dynamic';



  /**
   * champ libre (ou pas)
   * @param kind fdvf du champ
   * @returns 
   */
  public static isFreeField(kind: string): boolean {
    return kind === ViewData.FORM_HTML ||
      kind === ViewData.FORM_IMAGE ||
      kind === ViewData.FORM_ACTION ||
      kind === ViewData.FORM_DROP ||
      kind === ViewData.FORM_ZONE;
  }

  public static DEFAULT_COLOR_SET: number = 4; // jeu de couleurs par défaut pour les widgets

  /**
   * wizUpdateModel: Boolean
   * Permet de dire si le model est en cour d'édition
   */
  private static _wizUpdateModel: boolean = false;
  public static set wizUpdateModel(value: boolean) {
    this._wizUpdateModel = value;
  }
  public static get wizUpdateModel(): boolean {
    return this._wizUpdateModel;
  }

  /**
   * map des états par widgets pour suivre les modifs en cours sur la vue 
   * (hasUpdate sur les forms)
   * permet de contrôler les demandes de navigation
   */
  public static widgetStateMap: Map<string, boolean> = new Map();

  public static get wizWidgetUpdate(): boolean {
    let result: boolean = false;
    [...ViewData.widgetStateMap.values()].forEach(b => {
      if(!!b) {
        result = true;
      }
    });
    return result;
  }

  /*
   * Permet de savoir si la vue root est complétement initialisée
   */
  public _rootViewInitComplete: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public get rootViewInitComplete(): BehaviorSubject<boolean> {
    return this._rootViewInitComplete;
  }

  public isRootViewInitComplete(): boolean {
    return this._rootViewInitComplete.getValue();
  }

  // ####
  // ####
  // #### éléments techniques & fake elements ####
  // ####

  /** comparateurs disponibles par types de données */
  private _extComparatorList: ComparatorVO[] = null;
  public get extComparatorList(): ComparatorVO[] {
    if (!this._extComparatorList) {
      const result: ComparatorVO[] = [];
      result.push(new ComparatorVO(COMPARATOR.INF, '<', '$.comparator.inferior.$', 1, [FIELD_KIND.NUMBER, FIELD_KIND.INT, FIELD_KIND.DATE]));
      result.push(new ComparatorVO(COMPARATOR.INFEQUAL, '<=', '$.comparator.inferior.equal.$', 2, [FIELD_KIND.NUMBER, FIELD_KIND.DATE]));
      result.push(new ComparatorVO(COMPARATOR.EQUAL, '=', '$.comparator.equal.$', 3, [FIELD_KIND.NUMBER, FIELD_KIND.INT, FIELD_KIND.DATE, FIELD_KIND.BOOLEAN, FIELD_KIND.STRING, FIELD_KIND.TRS_LABEL, FIELD_KIND.LIST, FIELD_KIND.FILTER, FIELD_KIND.CROSS_FILTER]));
      result.push(new ComparatorVO(COMPARATOR.NOTEQUAL, '<>', '$.comparator.notequal.$', 4, [FIELD_KIND.NUMBER, FIELD_KIND.INT, FIELD_KIND.DATE, FIELD_KIND.BOOLEAN, FIELD_KIND.STRING, FIELD_KIND.TRS_LABEL, FIELD_KIND.LIST, FIELD_KIND.FILTER, FIELD_KIND.CROSS_FILTER]));
      result.push(new ComparatorVO(COMPARATOR.SUPEQUAL, '>=', '$.comparator.superior.equal.$', 5, [FIELD_KIND.NUMBER, FIELD_KIND.INT, FIELD_KIND.DATE]));
      result.push(new ComparatorVO(COMPARATOR.SUP, '>', '$.comparator.superior.$', 6, [FIELD_KIND.NUMBER, FIELD_KIND.INT, FIELD_KIND.DATE]));
      result.push(new ComparatorVO(COMPARATOR.BET, '>#<', '$.comparator.between.$', 7, [FIELD_KIND.NUMBER, FIELD_KIND.INT, FIELD_KIND.DATE], 2));
      result.push(new ComparatorVO(COMPARATOR.EMPTY, '!#', '$.comparator.empty.$', 8, [FIELD_KIND.NUMBER, FIELD_KIND.INT, FIELD_KIND.DATE, FIELD_KIND.STRING, FIELD_KIND.TRS_LABEL, FIELD_KIND.LIST, FIELD_KIND.FILTER, FIELD_KIND.CROSS_FILTER], 0));
      result.push(new ComparatorVO(COMPARATOR.NOTEMPTY, '#', '$.comparator.notempty.$', 9, [FIELD_KIND.NUMBER, FIELD_KIND.INT, FIELD_KIND.DATE, FIELD_KIND.STRING, FIELD_KIND.TRS_LABEL, FIELD_KIND.LIST, FIELD_KIND.FILTER, FIELD_KIND.CROSS_FILTER], 0));
      result.push(new ComparatorVO(COMPARATOR.STARTWITH, '>#', '$.comparator.startWith.$', 10, [FIELD_KIND.STRING, FIELD_KIND.TRS_LABEL], 1));
      result.push(new ComparatorVO(COMPARATOR.CONTAINS, '<#>', '$.comparator.contains.$', 11, [FIELD_KIND.STRING, FIELD_KIND.TRS_LABEL, FIELD_KIND.LIST, FIELD_KIND.FILTER, FIELD_KIND.CROSS_FILTER], 1));
      result.push(new ComparatorVO(COMPARATOR.USER, 'USER', '$.comparator.user.$', 12, [FIELD_KIND.STRING], 0));
      result.push(new ComparatorVO(COMPARATOR.USER_OR_NULL, 'USER0', '$.comparator.userornull.$', 13, [FIELD_KIND.STRING], 0));
      this._extComparatorList = result;
    }
    return this._extComparatorList;
  }

  /**
   * retourne le comparateur par son code
   * @param code: comparateur
   * @returns comparatorVO
   */
  public getExtComparator(code: string): ComparatorVO {
    const map: Map<string, ComparatorVO> = new Map(this.extComparatorList.map(item => [item.code, item]));
    return map.get(code);
  }

  /**
   * pour un type de donnée, retour les comparateurs élégibles
   * @param datakind: type de donnée cible
   * @returns comparateurs éligibles
   */
  public getExtComparatorSet(datakind: string): ComparatorVO[] {
    return this.extComparatorList.filter(comp => comp.datakind.has(datakind));
  }



  /** Freedata comparateurs (vue des styles) */
  private _comparatorList: FakeVO[] = null;
  public get comparatorList(): FakeVO[] {
    if (!this._comparatorList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO('<', '$.comparator.inferior.$', 1));
      result.push(new FakeVO('<=', '$.comparator.inferior.equal.$', 2));
      result.push(new FakeVO('=', '$.comparator.equal.$', 3));
      result.push(new FakeVO('<>', '$.comparator.notequal.$', 4));
      result.push(new FakeVO('>=', '$.comparator.superior.equal.$', 5));
      result.push(new FakeVO('>', '$.comparator.superior.$', 6));
      result.push(new FakeVO('Exp', '$.comparator.expression.$', 7));
      result.push(new FakeVO('User', '$.comparator.user.$', 8));
      this._comparatorList = result;
    }
    return this._comparatorList;
  }

  public get comparatorMap(): Map<string, FakeVO> {
    return new Map(this.comparatorList.map((item) => [item.code, item]));
  }

  /** statuts de visions */
  private _visionStateList: FakeVO[] = null;
  public get visionStateList(): FakeVO[] {
    if (!this._visionStateList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO('INIT', '$.vision.state.init.$', 1));
      result.push(new FakeVO('TEST', '$.vision.state.test.$', 2));
      result.push(new FakeVO('READY', '$.vision.state.ready.$', 3));
      result.push(new FakeVO('RUNNING', '$.vision.state.running.$', 4));
      result.push(new FakeVO('ENDED', '$.vision.state.ended.$', 5));
      this._visionStateList = result;
    }
    return this._visionStateList;
  }

  /** type de champs */
  private _datatypeList: FakeVO[] = null;
  public get datatypeList(): FakeVO[] {
    if (!this._datatypeList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(FIELD_KIND.STRING, '$.datatype.string.$', 1));
      result.push(new FakeVO(FIELD_KIND.INT, '$.datatype.int.$', 2));
      result.push(new FakeVO(FIELD_KIND.NUMBER, '$.datatype.number.$', 3));
      result.push(new FakeVO(FIELD_KIND.CONSTANT, '$.datatype.constant.$', 4));
      result.push(new FakeVO(FIELD_KIND.DATE, '$.datatype.date.$', 5));
      result.push(new FakeVO(FIELD_KIND.TIME, '$.datatype.time.$', 6));
      result.push(new FakeVO(FIELD_KIND.BOOLEAN, '$.datatype.boolean.$', 7));
      result.push(new FakeVO(FIELD_KIND.BINARY, '$.datatype.binary.$', 8));
      result.push(new FakeVO(FIELD_KIND.SUB_LINES, '$.datatype.sublines.$', 9));
      result.push(new FakeVO(FIELD_KIND.LIST, '$.datatype.list.$', 10));
      result.push(new FakeVO(FIELD_KIND.COMMENT, '$.datatype.comment.$', 11));
      result.push(new FakeVO(FIELD_KIND.ACTION, '$.datatype.action.$', 12));
      result.push(new FakeVO(FIELD_KIND.FILE, '$.datatype.file.$', 13));
      result.push(new FakeVO(FIELD_KIND.COLOR, '$.datatype.color.$', 14));
      result.push(new FakeVO(FIELD_KIND.FILTER, '$.log.key.FILTERKEY.$', 15));
      result.push(new FakeVO(FIELD_KIND.WORKFLOW, '$.datatype.workflow.$', 16));
      result.push(new FakeVO(FIELD_KIND.BINARY_MULTI, '$.datatype.binary.multi.$', 17));
      result.push(new FakeVO(FIELD_KIND.THRESHOLD, '$.datatype.threshold.$', 18));
      result.push(new FakeVO(FIELD_KIND.CROSS_FILTER, '$.datatype.CROSSFILTER.$', 15));
      this._datatypeList = result;
    }
    return this._datatypeList;
  }


  /** type de champs complémentaires */
  private _moreArgstypeList: FakeVO[] = null;
  public get moreArgstypeList(): FakeVO[] {
    if (!this._moreArgstypeList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(FIELD_KIND.STRING, '$.datatype.string.$', 1));
      result.push(new FakeVO(FIELD_KIND.INT, '$.datatype.int.$', 2));
      result.push(new FakeVO(FIELD_KIND.NUMBER, '$.datatype.number.$', 3));
      result.push(new FakeVO(FIELD_KIND.DATE, '$.datatype.date.$', 4));
      result.push(new FakeVO(FIELD_KIND.BOOLEAN, '$.datatype.boolean.$', 5));
      result.push(new FakeVO(FIELD_KIND.BINARY, '$.datatype.binary.$', 6));
      result.push(new FakeVO(FIELD_KIND.OBJECT, '$.datatype.object.$', 7));
      result.push(new FakeVO(FIELD_KIND.COMMENT, '$.datatype.comment.$', 8));
      result.push(new FakeVO(FIELD_KIND.ACTION, '$.datatype.action.$', 9));
      result.push(new FakeVO(FIELD_KIND.FORMULA, '$.datatype.formula.$', 10));
      result.push(new FakeVO(FIELD_KIND.FILE, '$.datatype.file.$', 11));
      result.push(new FakeVO(FIELD_KIND.COLOR, '$.datatype.color.$', 12));
      result.push(new FakeVO(FIELD_KIND.WORKFLOW, '$.datatype.workflow.$', 13));
      result.push(new FakeVO(FIELD_KIND.BINARY_MULTI, '$.datatype.binary.multi.$', 14));
      result.push(new FakeVO(FIELD_KIND.LIST, '$.datatype.list.$', 15));
      result.push(new FakeVO(FIELD_KIND.THRESHOLD, '$.datatype.threshold.$', 16));
      this._moreArgstypeList = result;
    }
    return this._moreArgstypeList;
  }

  /** modes de cnx sync / async pour connec */
  private _connectModeList: FakeVO[] = null;
  public get connectModeList(): FakeVO[] {
    if (!this._connectModeList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(PROCESS_MODE.SYNC, '$.connect.mode.sync.$', 1));
      result.push(new FakeVO(PROCESS_MODE.ASYNC, '$.connect.mode.async.$', 2));
      this._connectModeList = result;
    }
    return this._connectModeList;
  }


  /** collection d'objets pour formatage d'index */
  public indexFormatList: any[] = [
    { code: '1', label: '1, 2, 3...' },
    { code: '11', label: '01, 02, 03...' },
    { code: 'a', label: 'a, b, c...' },
    { code: 'A', label: 'A, B, C...' },
  ];

  /** Liste de droit pour les roles */
  public accessGrantList: any[] = [
    { code: 'doRead', label: '$.access.grant.doread.$' },
    { code: 'doUpdate', label: '$.access.grant.doupdate.$' },
    { code: 'doCreate', label: '$.access.grant.docreate.$' },
    { code: 'doDelete', label: '$.access.grant.dodelete.$' },
  ];

  /**
   * Liste de faux modèles de chronocodes pre-configurés
   */
  public fakeChronoCodeModel: any[] = [
    { code: 'Année', trsLabel: 'découpage en année' },
    { code: 'Mois', trsLabel: 'découpage en mois' },
    { code: 'Exemple 3', trsLabel: 'Description de exemple 3' },
    { code: 'Exemple 4', trsLabel: 'Description de exemple 4' },
    { code: 'Exemple 5', trsLabel: 'Description de exemple 5' },
    { code: 'Exemple 6', trsLabel: 'Description de exemple 6' },
    { code: 'Exemple 7', trsLabel: 'Description de exemple 7' },
    { code: 'Exemple 8', trsLabel: 'Description de exemple 8' },
    { code: 'Exemple 9', trsLabel: 'Description de exemple 9' },
  ];

  /**
   * Liste de faux modèles de codifications pre-configurées
   */
  public fakeFreeDataModel: any[] = [
    { code: 'Colors', trsLabel: 'les couleurs basiques' },
    { code: 'Regions', trsLabel: 'Découpage par région de la France' },
    { code: 'Exemple 3', trsLabel: 'Description de exemple 3' },
    { code: 'Exemple 4', trsLabel: 'Description de exemple 4' },
    { code: 'Exemple 5', trsLabel: 'Description de exemple 5' },
    { code: 'Exemple 6', trsLabel: 'Description de exemple 6' },
    { code: 'Exemple 7', trsLabel: 'Description de exemple 7' },
    { code: 'Exemple 8', trsLabel: 'Description de exemple 8' },
    { code: 'Exemple 9', trsLabel: 'Description de exemple 9' },
  ];

  /**
   * Liste des jours pour le début de la semaine
   */
  public fakeWeekStartDay: any[] = [
    { code: 'lundi', trsLabel: 'Lundi', value: 1 },
    { code: 'dimanche', trsLabel: 'Dimanche', value: 7 },
  ];

  /** prefix par défaut des semaines */
  public weeksPrefix: string = 'S';

  /** mode de lancement des applis */
  private _runModeList: FakeVO[] = null;
  public get runModeList(): FakeVO[] {
    if (!this._runModeList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO('TEST', '$.run.mode.test.$', 1));
      result.push(new FakeVO('QUAL', '$.run.mode.qual.$', 2));
      result.push(new FakeVO('PROD', '$.run.mode.prod.$', 3));
      this._runModeList = result;
    }
    return this._runModeList;
  }

  /** alignement des cellules et des headers */
  private _textAlignList: FakeVO[] = null;
  public get textAlignList(): FakeVO[] {
    if (!this._textAlignList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO('R', '$.common.text.right.$', 3));
      result.push(new FakeVO('C', '$.common.text.center.$', 2));
      result.push(new FakeVO('L', '$.common.text.left.$', 1));
      this._textAlignList = result;
    }
    return this._textAlignList;
  }

  /** alignement des cellules et des headers */
  private _screenModes: FakeVO[] = null;
  public get screenModes(): FakeVO[] {
    if (!this._screenModes) {
      const result: FakeVO[] = [];
      result.push(new FakeVO('fixed', '$.screen.fixed.$', 1));
      result.push(new FakeVO('verticalFixed', '$.screen.verticalfixed.$', 2));
      result.push(new FakeVO('horizontalFixed', '$.screen.horizontalfixed.$', 3));
      result.push(new FakeVO('fit', '$.screen.fit.$', 4));
      this._screenModes = result;
    }
    return this._screenModes;
  }

  /** Freedata Alphabet (non traductible) */
  public alphabetList: any[] = [
    { freedatacode: 'ALPHABET', freedatavaluecode: 'LATIN' },
    { freedatacode: 'ALPHABET', freedatavaluecode: 'CYRILLIC' },
    { freedatacode: 'ALPHABET', freedatavaluecode: 'HANGEUL' }
  ];

  /** construction du FD fake "Alphabet" pour la vue language */
  private _alphabetFD: any[] = null;
  public alphabetFD(): any[] {
    if (!this._alphabetFD) {
      const fd: any[] = [];
      this.alphabetList.forEach(val => {
        const fdv: any = {};
        fdv.code = val.freedatavaluecode;
        fdv.trsLabel = val.freedatavaluecode;
        fd.push(fdv);
      });
      this._alphabetFD = fd;
    }
    return this._alphabetFD;
  }

  /** types de connexions possibles pour Cnx */
  private _connectionKindList: FakeVO[] = null;
  public get connectionKindList(): FakeVO[] {
    if (!this._connectionKindList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(CNX_KIND.API, '$.cnx.kind.API.$', 1));
      result.push(new FakeVO(CNX_KIND.BDD, '$.cnx.kind.BDD.$', 2));
      result.push(new FakeVO(CNX_KIND.FTP, '$.cnx.kind.FTP.$', 3));
      result.push(new FakeVO(CNX_KIND.AUTHAPI, '$.cnx.kind.AUTHAPI.$', 4));
      this._connectionKindList = result;
    }
    return this._connectionKindList;
  }

  /** types de connexions possibles pour Cnx */
  private _bddList: FakeVO[] = null;
  public get bddList(): FakeVO[] {
    if (!this._bddList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(BDD_KIND.POSTGRES, '$.bdd.kind.POSTGRES.$', 1));
      result.push(new FakeVO(BDD_KIND.ORACLE, '$.bdd.kind.ORACLE.$', 2));
      result.push(new FakeVO(BDD_KIND.MYSQL, '$.bdd.kind.MYSQL.$', 3));
      result.push(new FakeVO(BDD_KIND.ALLKEYME, '$.bdd.kind.ALLKEYME.$', 4));
      this._bddList = result;
    }
    return this._bddList;
  }

  /** types de connexions possibles pour FTP */
  private _ftpProtocolList: FakeVO[] = null;
  public get ftpProtocolList(): FakeVO[] {
    if (!this._ftpProtocolList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(FTP_PROTOCOL_KIND.FTP, FTP_PROTOCOL_KIND.FTP, 1));
      result.push(new FakeVO(FTP_PROTOCOL_KIND.FTPS, FTP_PROTOCOL_KIND.FTPS, 2));
      result.push(new FakeVO(FTP_PROTOCOL_KIND.SFTP, FTP_PROTOCOL_KIND.SFTP, 3));
      this._ftpProtocolList = result;
    }
    return this._ftpProtocolList;
  }


  /** types de méthodes d'appel pour les APIs */
  private _apiMethodList: FakeVO[] = null;
  public get apiMethodList(): FakeVO[] {
    if (!this._apiMethodList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(WIZ_COMMAND_HTTP_METHOD.GET.toUpperCase(), WIZ_COMMAND_HTTP_METHOD.GET.toUpperCase(), 1));
      result.push(new FakeVO(WIZ_COMMAND_HTTP_METHOD.POST.toUpperCase(), WIZ_COMMAND_HTTP_METHOD.POST.toUpperCase(), 2));
      result.push(new FakeVO(WIZ_COMMAND_HTTP_METHOD.PUT.toUpperCase(), WIZ_COMMAND_HTTP_METHOD.PUT.toUpperCase(), 3));
      result.push(new FakeVO(WIZ_COMMAND_HTTP_METHOD.PATCH.toUpperCase(), WIZ_COMMAND_HTTP_METHOD.PATCH.toUpperCase(), 4));
      result.push(new FakeVO(WIZ_COMMAND_HTTP_METHOD.DELETE.toUpperCase(), WIZ_COMMAND_HTTP_METHOD.DELETE.toUpperCase(), 5));

      this._apiMethodList = result;
    }
    return this._apiMethodList;
  }

  /** types de formats de contenus pour les APIs */
  private _apiFormatList: FakeVO[] = null;
  public get apiFormatList(): FakeVO[] {
    if (!this._apiFormatList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(API_FORMAT.JSON, API_FORMAT.JSON, 1));
      result.push(new FakeVO(API_FORMAT.XML, API_FORMAT.XML, 2));
      result.push(new FakeVO(API_FORMAT.RAW, API_FORMAT.RAW, 3));
      this._apiFormatList = result;
    }
    return this._apiFormatList;
  }


  /** types de formats de contenus pour les APIs */
  private _authKindList: FakeVO[] = null;
  public get authKindList(): FakeVO[] {
    if (!this._authKindList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(AUTH_KIND.SAML, AUTH_KIND.SAML, 1));
      result.push(new FakeVO(AUTH_KIND.OPENID, AUTH_KIND.OPENID, 2));
      result.push(new FakeVO(AUTH_KIND.BASIC_AUTH, AUTH_KIND.BASIC_AUTH, 4));
      result.push(new FakeVO(AUTH_KIND.GOOGLE, AUTH_KIND.GOOGLE, 4));
      result.push(new FakeVO(AUTH_KIND.FACEBOOK, AUTH_KIND.FACEBOOK, 5));
      this._authKindList = result;
    }
    return this._authKindList;
  }


  /** types de valeurs pour les params d'appels d'APIs */
  private _apiParamKindList: FakeVO[] = null;
  public get apiParamKindList(): FakeVO[] {
    if (!this._apiParamKindList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(API_PARAM_KIND.API_URL_PARAM_LOCATION, API_PARAM_KIND.API_URL_PARAM_LOCATION, 1));
      result.push(new FakeVO(API_PARAM_KIND.API_HEADER_PARAM_LOCATION, API_PARAM_KIND.API_HEADER_PARAM_LOCATION, 2));
      result.push(new FakeVO(API_PARAM_KIND.API_BODY_PARAM_LOCATION, API_PARAM_KIND.API_BODY_PARAM_LOCATION, 3));
      this._apiParamKindList = result;
    }
    return this._apiParamKindList;
  }

  /** types de tables de travail IN OUT BOTH */
  private _tableWayList: FakeVO[] = null;
  public get tableWayList(): FakeVO[] {
    if (!this._tableWayList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(WORKING_TABLE_WAY.IN_WORKING_TABLE, '$.proc.table.in.$', 1));
      result.push(new FakeVO(WORKING_TABLE_WAY.OUT_WORKING_TABLE, '$.proc.table.out.$', 2));
      result.push(new FakeVO(WORKING_TABLE_WAY.IN_OUT_WORKING_TABLE, '$.proc.table.inout.$', 3));
      this._tableWayList = result;
    }
    return this._tableWayList;
  }

  /** types SQL */
  private _sqlTypeList: FakeVO[] = null;
  public get sqlTypeList(): FakeVO[] {
    if (!this._sqlTypeList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(SQL_TYPE.SQL_TYPE_STR, '$.common.sql.str.$', 1));
      result.push(new FakeVO(SQL_TYPE.SQL_TYPE_INT, '$.common.sql.int.$', 2));
      result.push(new FakeVO(SQL_TYPE.SQL_TYPE_LONG, '$.common.sql.long.$', 3));
      result.push(new FakeVO(SQL_TYPE.SQL_TYPE_DECIMAL, '$.common.sql.decimal.$', 4));
      result.push(new FakeVO(SQL_TYPE.SQL_TYPE_BOOLEAN, '$.common.sql.boolean.$', 5));
      result.push(new FakeVO(SQL_TYPE.SQL_TYPE_JSONB, '$.common.sql.jsonb.$', 6));
      result.push(new FakeVO(SQL_TYPE.SQL_TYPE_DATE, '$.common.sql.date.$', 7));
      this._sqlTypeList = result;
    }
    return this._sqlTypeList;
  }

  /** types SQL en map, pour chopper les libellés */
  private _sqlTypeMap: Map<string, FakeVO> = null;
  public get sqlTypeMap(): Map<string, FakeVO> {
    if (!this._sqlTypeMap) {
      this._sqlTypeMap = new Map(this.sqlTypeList.map(item => [item.code, item]));
    }
    return this._sqlTypeMap;
  }


  /** types de params SQL */
  private _sqlParamTypeList: FakeVO[] = null;
  public get sqlParamTypeList(): FakeVO[] {
    if (!this._sqlParamTypeList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(PREDEFINED_SQL_PARAM.PROCESS_DOMAIN, '$.common.sql.param.PROCESS_DOMAIN.$', 1));
      result.push(new FakeVO(PREDEFINED_SQL_PARAM.PROCESS_BU, '$.common.sql.param.PROCESS_BU.$', 2));
      result.push(new FakeVO(PREDEFINED_SQL_PARAM.PROCESS_VISION, '$.common.sql.param.PROCESS_VISION.$', 3));
      result.push(new FakeVO(PREDEFINED_SQL_PARAM.PROCESS_UUID, '$.common.sql.param.PROCESS_UUID.$', 4));
      result.push(new FakeVO(PREDEFINED_SQL_PARAM.ENGINE, '$.common.sql.param.ENGINE.$', 5));
      result.push(new FakeVO(PREDEFINED_SQL_PARAM.CUSTOM, '$.common.sql.param.CUSTOM.$', 6));
      this._sqlParamTypeList = result;
    }
    return this._sqlParamTypeList;
  }




  /** types de valeurs pour les params engine */
  private _engineKindList: FakeVO[] = null;
  public get engineKindList(): FakeVO[] {
    if (!this._engineKindList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(ENGINE_KIND.STR, ENGINE_KIND.STR, 1));
      result.push(new FakeVO(ENGINE_KIND.LONG, ENGINE_KIND.LONG, 2));
      result.push(new FakeVO(ENGINE_KIND.BOOLEAN, ENGINE_KIND.BOOLEAN, 3));
      result.push(new FakeVO(ENGINE_KIND.TIMESTAMP, ENGINE_KIND.TIMESTAMP, 4));
      result.push(new FakeVO(ENGINE_KIND.SEQUENCE, ENGINE_KIND.SEQUENCE, 5));
      result.push(new FakeVO(ENGINE_KIND.FREEDATA, ENGINE_KIND.FREEDATA, 6));
      result.push(new FakeVO(ENGINE_KIND.FREEDATAVALUE, ENGINE_KIND.FREEDATAVALUE, 7));
      result.push(new FakeVO(ENGINE_KIND.CHRONOCODE, ENGINE_KIND.CHRONOCODE, 8));
      result.push(new FakeVO(ENGINE_KIND.VISION, ENGINE_KIND.VISION, 9));
      result.push(new FakeVO(ENGINE_KIND.FILTER, ENGINE_KIND.FILTER, 10));
      result.push(new FakeVO(ENGINE_KIND.PROCESS, ENGINE_KIND.PROCESS, 11));
      result.push(new FakeVO(ENGINE_KIND.FLOW, ENGINE_KIND.FLOW, 12));
      result.push(new FakeVO(ENGINE_KIND.BODY, ENGINE_KIND.BODY, 13));


      this._engineKindList = result;
    }
    return this._engineKindList;
  }

  /** types de connexions possibles pour FTP */
  private _decisionExitStatusList: FakeVO[] = null;
  public get decisionExitStatusList(): FakeVO[] {
    if (!this._decisionExitStatusList) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(EXIT_STATUS.COMPLETED, EXIT_STATUS.COMPLETED, 1));
      result.push(new FakeVO(EXIT_STATUS.FAILED, EXIT_STATUS.FAILED, 2));
      result.push(new FakeVO(EXIT_STATUS.MEDIUM, EXIT_STATUS.MEDIUM, 3));
      this._decisionExitStatusList = result;
    }
    return this._decisionExitStatusList;
  }

  /** types de steps prédéfinis */
  private _predefineStepKind: FakeVO[] = null;
  public get predefineStepKind(): FakeVO[] {
    if (!this._predefineStepKind) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(PREDEFINE_KIND.API_TO_CTX, '$.cnx.predef.API_TO_CTX.$', 1));
      result.push(new FakeVO(PREDEFINE_KIND.FILE_TO_TABLE, '$.cnx.predef.FILE_TO_TABLE.$', 2));
      result.push(new FakeVO(PREDEFINE_KIND.TABLE_TO_FILE, '$.cnx.predef.TABLE_TO_FILE.$', 3));

      result.push(new FakeVO(PREDEFINE_KIND.CALL_STORED_PROCEDURE, '$.cnx.predef.CALL_STORED_PROCEDURE.$', 4));
      result.push(new FakeVO(PREDEFINE_KIND.CALL_STORED_FUNCTION, '$.cnx.predef.CALL_STORED_FUNCTION.$', 5));
      result.push(new FakeVO(PREDEFINE_KIND.BUCKET_MOVE_FILE, '$.cnx.predef.BUCKET_MOVE_FILE.$', 6));

      result.push(new FakeVO(PREDEFINE_KIND.FTP_GET_FILE, '$.cnx.predef.FTP_GET_FILE.$', 7));
      result.push(new FakeVO(PREDEFINE_KIND.FTP_MOVE_FILE, '$.cnx.predef.FTP_MOVE_FILE.$', 8));
      result.push(new FakeVO(PREDEFINE_KIND.FTP_PUT_FILE, '$.cnx.predef.FTP_PUT_FILE.$', 9));


      result.push(new FakeVO(PREDEFINE_KIND.SAS_INTEGRATION, '$.cnx.predef.SAS_INTEGRATION.$', 10));
      result.push(new FakeVO(PREDEFINE_KIND.CONTEXT_DATA_DECISION, '$.cnx.predef.CONTEXT_DATA_DECISION.$', 11));
      result.push(new FakeVO(PREDEFINE_KIND.LOG_WRITER, '$.cnx.predef.LOG_WRITER.$', 12));
      result.push(new FakeVO(PREDEFINE_KIND.LOG_SIPHON, '$.cnx.predef.LOG_SIPHON.$', 13));
      result.push(new FakeVO(PREDEFINE_KIND.BUCKET_CLEANER, '$.bucket.title.$', 14));
      result.push(new FakeVO(PREDEFINE_KIND.TABLE_CLEANER, '$.tablecleaner.title.$', 15));
      result.push(new FakeVO(PREDEFINE_KIND.TABLE_TO_API, '$.tabletoapi.title.$', 15));
      result.push(new FakeVO(PREDEFINE_KIND.API_TO_TABLE, '$.apitotable.title.$', 16));
      result.push(new FakeVO(PREDEFINE_KIND.FILE_EXISTS, '$.fileexists.title.$', 17));
      this._predefineStepKind = result;
    }
    return this._predefineStepKind;
  }

  /** types de partitionnement pour les steps */
  private _partitionKind: FakeVO[] = null;
  public get partitionKind(): FakeVO[] {
    if (!this._partitionKind) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(PARTITION_KIND.PARTITION_FILE, '$.cnx.partition.kind.PARTITION_FILE.$', 1));
      result.push(new FakeVO(PARTITION_KIND.PARTITION_AKME, '$.cnx.partition.kind.PARTITION_AKME.$', 2));
      this._partitionKind = result;
    }
    return this._partitionKind;
  }

  /** event pour les step.event */
  private _stepEventKind: FakeVO[] = null;
  public get stepEventKind(): FakeVO[] {
    if (!this._stepEventKind) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(STEP_EVENT_KIND.BEFORE_STEP, '$.cnx.step.event.kind.BEFORE_STEP.$', 1));
      result.push(new FakeVO(STEP_EVENT_KIND.AFTER_STEP, '$.cnx.step.event.kind.AFTER_STEP.$', 2));
      this._stepEventKind = result;
    }
    return this._stepEventKind;
  }


  /** opérations pour les step.operation */
  private _engineOperationKind: FakeVO[] = null;
  public get engineOperationKind(): FakeVO[] {
    if (!this._engineOperationKind) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(ENGINE_OPERATION_KIND.ENGINE_READ, '$.cnx.step.operation.kind.ENGINE_READ.$', 1));
      result.push(new FakeVO(ENGINE_OPERATION_KIND.ENGINE_PREPARE, '$.cnx.step.operation.kind.ENGINE_PREPARE.$', 2));
      result.push(new FakeVO(ENGINE_OPERATION_KIND.ENGINE_WRITE, '$.cnx.step.operation.kind.ENGINE_WRITE.$', 3));
      result.push(new FakeVO(ENGINE_OPERATION_KIND.ENGINE_REMOVE, '$.cnx.step.operation.kind.ENGINE_REMOVE.$', 4));
      this._engineOperationKind = result;
    }
    return this._engineOperationKind;
  }

  /** Scen pour les step.operation */
  private _engineOperationScenKind: FakeVO[] = null;
  public get engineOperationScenKind(): FakeVO[] {
    if (!this._engineOperationScenKind) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(ENGINE_OPERATION_SCEN_KIND.SCEN_FREEDATA, '$.cnx.step.scen.kind.SCEN_FREEDATA.$', 1));
      result.push(new FakeVO(ENGINE_OPERATION_SCEN_KIND.SCEN_CHRONO, '$.cnx.step.scen.kind.SCEN_CHRONO.$', 2));
      result.push(new FakeVO(ENGINE_OPERATION_SCEN_KIND.SCEN_VISION, '$.cnx.step.scen.kind.SCEN_VISION.$', 3));
      this._engineOperationScenKind = result;
    }
    return this._engineOperationScenKind;
  }

  /** types de readers (step.reader) */
  private _stepReaderKind: FakeVO[] = null;
  public get stepReaderKind(): FakeVO[] {
    if (!this._stepReaderKind) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(READER_KIND.FILE, '$.cnx.step.reader.kind.FILE.$', 1));
      result.push(new FakeVO(READER_KIND.API, '$.cnx.step.reader.kind.API.$', 2));
      result.push(new FakeVO(READER_KIND.SQL, '$.cnx.step.reader.kind.SQL.$', 3));
      // result.push(new FakeVO(READER_KIND.CTX, '$.cnx.step.reader.kind.CTX.$', 4));
      result.push(new FakeVO(READER_KIND.CMP, '$.cnx.step.reader.kind.CMP.$', 4));
      this._stepReaderKind = result;
    }
    return this._stepReaderKind;
  }

  /** event pour les step.event */
  private _repeatConditionKind: FakeVO[] = null;
  public get repeatConditionKind(): FakeVO[] {
    if (!this._repeatConditionKind) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(REPEAT_CONDITION_KIND.WHILE_NOT_NULL_OR_EMPTY, '$.repeat.condition.kind.WHILE_NOT_NULL_OR_EMPTY.$', 1));
      result.push(new FakeVO(REPEAT_CONDITION_KIND.WHILE_NOT_EQUALS, '$.repeat.condition.kind.REPEAT_CONDITION_KIND.$', 2));
      this._repeatConditionKind = result;
    }
    return this._repeatConditionKind;
  }

  /** types de Writer (step.Writer) */
  private _stepWriterKind: FakeVO[] = null;
  public get stepWriterKind(): FakeVO[] {
    if (!this._stepWriterKind) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(WRITER_KIND.FILE, '$.cnx.step.writer.kind.FILE.$', 1));
      result.push(new FakeVO(WRITER_KIND.SQL, '$.cnx.step.writer.kind.SQL.$', 2));
      result.push(new FakeVO(WRITER_KIND.FREEDATA, '$.cnx.step.writer.kind.FREEDATA.$', 3));
      result.push(new FakeVO(WRITER_KIND.BASELINE, '$.cnx.step.writer.kind.BASELINE.$', 4));
      this._stepWriterKind = result;
    }
    return this._stepWriterKind;
  }

  /** types de field pour les processor */
  private _processorWay: FakeVO[] = null;
  public get processorWay(): FakeVO[] {
    if (!this._processorWay) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(PROCESSOR_WAY.IN, '$.cnx.processor.way.IN.$', 1));
      result.push(new FakeVO(PROCESSOR_WAY.OUT, '$.cnx.processor.way.OUT.$', 2));
      result.push(new FakeVO(PROCESSOR_WAY.VAR, '$.cnx.processor.way.VAR.$', 3));
      result.push(new FakeVO(PROCESSOR_WAY.CONST, '$.cnx.processor.way.CONST.$', 4));
      this._processorWay = result;
    }
    return this._processorWay;
  }

  /** types pour les processor */
  private _processorType: FakeVO[] = null;
  public get processorType(): FakeVO[] {
    if (!this._processorType) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(PROCESSOR_TYPE.STR, '$.common.sql.str.$', 1));
      result.push(new FakeVO(PROCESSOR_TYPE.INT, '$.common.sql.int.$', 2));
      result.push(new FakeVO(PROCESSOR_TYPE.LONG, '$.common.sql.long.$', 3));
      result.push(new FakeVO(PROCESSOR_TYPE.DECIMAL, '$.common.sql.decimal.$', 4));
      result.push(new FakeVO(PROCESSOR_TYPE.BOOLEAN, '$.common.sql.boolean.$', 5));
      result.push(new FakeVO(PROCESSOR_TYPE.OBJECT, '$.common.sql.object.$', 6));
      result.push(new FakeVO(PROCESSOR_TYPE.DATE, '$.common.sql.date.$', 7));
      result.push(new FakeVO(PROCESSOR_TYPE.MAP, '$.common.sql.map.$', 8));
      this._processorType = result;
    }
    return this._processorType;
  }

  /** type de donnée de contexte */
  private _contextDataKind: FakeVO[] = null;
  public get contextDataKind(): FakeVO[] {
    if (!this._contextDataKind) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(CONTEXT_DATA.ENGINE, '$.context.data.ENGINE.$', 1));
      result.push(new FakeVO(CONTEXT_DATA.PREDEFINED, '$.context.data.PREDEFINED.$', 2));
      this._contextDataKind = result;
    }
    return this._contextDataKind;
  }

  /** type de donnée de contexte */
  private _connectReturnActionKind: FakeVO[] = null;
  public get connectReturnActionKind(): FakeVO[] {
    if (!this._connectReturnActionKind) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(CONNECT_RETURN_ACTION.NONE, '$.connect.return.action.NONE.$', 1));
      result.push(new FakeVO(CONNECT_RETURN_ACTION.REFRESH, '$.connect.return.action.REFRESH.$', 2));
      result.push(new FakeVO(CONNECT_RETURN_ACTION.SYNC, '$.connect.return.action.SYNC.$', 3));
      result.push(new FakeVO(CONNECT_RETURN_ACTION.POP, '$.connect.return.action.POP.$', 4));
      this._connectReturnActionKind = result;
    }
    return this._connectReturnActionKind;
  }


  /** types pour les opérations sur processor */
  private _processorOpType: FakeVO[] = null;
  public get processorOpType(): FakeVO[] {
    if (!this._processorOpType) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(PROC_OP_TYPE.CONCAT, '$.proc.op.CONCAT.$', 1));
      // result.push(new FakeVO(PROC_OP_TYPE.CONSTANT, '$.proc.op.CONSTANT.$', 2));
      result.push(new FakeVO(PROC_OP_TYPE.CONTEXT_DATA_PERSIST, '$.proc.op.CONTEXT_DATA_PERSIST.$', 3));
      // result.push(new FakeVO(PROC_OP_TYPE.CONTEXT_VARIABLE, '$.proc.op.CONTEXT_VARIABLE.$', 4));
      result.push(new FakeVO(PROC_OP_TYPE.COPY, '$.proc.op.COPY.$', 5));
      result.push(new FakeVO(PROC_OP_TYPE.DATESTR, '$.proc.op.DATESTR.$', 6));
      result.push(new FakeVO(PROC_OP_TYPE.DECODE, '$.proc.op.DECODE.$', 7));
      result.push(new FakeVO(PROC_OP_TYPE.DECODE_FDARGVAL, '$.proc.op.DECODE_FDARGVAL.$', 8));

      result.push(new FakeVO(PROC_OP_TYPE.FDARGVAL, '$.proc.op.FDARGVAL.$', 11));
      result.push(new FakeVO(PROC_OP_TYPE.FDVAL, '$.proc.op.FDVAL.$', 12));
      // result.push(new FakeVO(PROC_OP_TYPE.INIT_CONST_VARIABLE, '$.proc.op.INIT_CONST_VARIABLE.$', 13));
      // result.push(new FakeVO(PROC_OP_TYPE.INIT_CONTEXT_VARIABLE, '$.proc.op.INIT_CONTEXT_VARIABLE.$', 14));
      // result.push(new FakeVO(PROC_OP_TYPE.INIT_OUT_ID_FIELD_VARIABLE, '$.proc.op.INIT_OUT_ID_FIELD_VARIABLE.$', 15));
      // result.push(new FakeVO(PROC_OP_TYPE.OUT_FIELD_VARIABLE, '$.proc.op.OUT_FIELD_VARIABLE.$', 16));
      // result.push(new FakeVO(PROC_OP_TYPE.OUT_ID_FIELD_VARIABLE, '$.proc.op.OUT_ID_FIELD_VARIABLE.$', 17));
      result.push(new FakeVO(PROC_OP_TYPE.REPLACE, '$.proc.op.REPLACE.$', 18));
      result.push(new FakeVO(PROC_OP_TYPE.IFNULLOREMPTY, '$.proc.op.IFNULLOREMPTY.$', 19));


      result.push(new FakeVO(PROC_OP_TYPE.ROW_LOOP, '$.proc.op.ROW_LOOP.$', 21));
      result.push(new FakeVO(PROC_OP_TYPE.ROW_PERSIST, '$.proc.op.ROW_PERSIST.$', 22));
      result.push(new FakeVO(PROC_OP_TYPE.ROW_SELECT, '$.proc.op.ROW_SELECT.$', 23));
      // result.push(new FakeVO(PROC_OP_TYPE.ROW_FIELD_VARIABLE, '$.proc.op.ROW_FIELD_VARIABLE.$', 24));
      result.push(new FakeVO(PROC_OP_TYPE.SPLIT, '$.proc.op.SPLIT.$', 25));
      // result.push(new FakeVO(PROC_OP_TYPE.VARIABLE, '$.proc.op.VARIABLE.$', 26));
      this._processorOpType = result;
    }
    return this._processorOpType;
  }

  /** type de champ à alimenter pour les logs */
  private _logKeyKind: FakeVO[] = null;
  public get logKeyKind(): FakeVO[] {
    if (!this._logKeyKind) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(LOG_KEY_KIND.KEY, '$.log.key.KEY.$', 1));
      result.push(new FakeVO(LOG_KEY_KIND.FILTERKEY, '$.log.key.FILTERKEY.$', 2));
      result.push(new FakeVO(LOG_KEY_KIND.VALUE, '$.log.key.VALUE.$', 3));
      result.push(new FakeVO(LOG_KEY_KIND.CONSTANT, '$.fc.mapping.CONSTANT.$', 4));
      // result.push(new FakeVO(LOG_KEY_KIND.CRITERIA, '$.log.key.KEY.$', 4));
      this._logKeyKind = result;
    }
    return this._logKeyKind;
  }

  /** type de champ spéciaux pour les mapping filte-table */
  private _mappingSpecialKind: FakeVO[] = null;
  public get mappingSpecialKind(): FakeVO[] {
    if (!this._mappingSpecialKind) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(MAPPING_SPECIAL_KIND.ROW_INDEX, '$.fc.mapping.ROW_INDEX.$', 1));
      result.push(new FakeVO(MAPPING_SPECIAL_KIND.ROW, '$.fc.mapping.ROW.$', 2));
      result.push(new FakeVO(MAPPING_SPECIAL_KIND.CONSTANT, '$.fc.mapping.CONSTANT.$', 3));
      // result.push(new FakeVO(MAPPING_SPECIAL_KIND.ERROR, '$.fc.mapping.ERROR.$', 4));
      this._mappingSpecialKind = result;
    }
    return this._mappingSpecialKind;
  }

  /** états workflow */
  private _workflowState: FakeVO[] = null;
  public get workflowState(): FakeVO[] {
    if (!this._workflowState) {
      const result: FakeVO[] = [];
      result.push(new FakeVO(WORKFLOW_STATE.INIT, '$.wf.init.$', 1, "string", "🚀", 'rocket'));
      result.push(new FakeVO(WORKFLOW_STATE.PENDING, '$.wf.pending.$', 2, "string", "⏳", 'hourglass_empty'));
      result.push(new FakeVO(WORKFLOW_STATE.ASSIGN, '$.wf.assign.$', 3, "string", "🙋‍♂️", 'assignment_ind'));
      result.push(new FakeVO(WORKFLOW_STATE.OK, '$.wf.ok.$', 4, "string", "👍", 'check_circle'));
      result.push(new FakeVO(WORKFLOW_STATE.KO, '$.wf.ko.$', 5, "string", "👎", 'sentiment_very_dissatisfied'));
      result.push(new FakeVO(WORKFLOW_STATE.CLOSED, '$.wf.closed.$', 6, "string", "🤝", 'approval'));
      this._workflowState = result;
    }
    return this._workflowState;
  }

}


